/**
 *
 * @typedef {import('src/utils/hooks/usePermissions').Permission} Permission
 *
 * @typedef {Object} OrganizationWorkRoleRelationshop
 * @property {Permission[]} permissions
 *
 * @typedef {Object} WorkRoleRelationship
 * @property {WorkRole} workRole
 * @property {string} workRoleId
 * @property {string} workRoleLabel
 *
 * @typedef {Object} WorkRole
 * @property {Permission[]} permissions
 * @property {OrganizationWorkRoleRelationshop[]} organization_workroles
 *
 * @typedef {Object} OrgAttachments
 * @property {string} iconLogo
 *
 *
 * @typedef {Object} Timezone
 * @property {string} utc
 * @property {string} abbr
 *
 *
 * @typedef {Object} Organization
 * @property {string} id
 * @property {number} creditAmount
 * @property {Timezone} timezone
 * @property {string} legalName
 * @property {number} created_at
 * @property {OrgAttachments} attachments
 * @property {string} billingEmail
 * @property {Object} billingAddress
 * @property {"email"|"credit_card"|null} billing_method
 * @property {"monthly"|"annual"|null} billing_frequency
 *
 * @typedef {Object} UserAttachments
 * @property {string} iconLogo
 *
 * @typedef {Object} Timezone
 * @property {string} utc
 * @property {string} abbr
 *
 *
 * @typedef {Object} User
 * @property {string} id
 * @property {string} email
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} phoneNumber
 * @property {UserAttachments} attachments
 * @property {boolean} isAdministrator
 * @property {string} auth0UserId
 * @property {number} created_at
 * @property {string} organizationId
 * @property {string} lastSeenNotificationId
 * @property {Organization} organization
 * @property {WorkRoleRelationship[]} workRoles
 *
 */
import { createContext } from 'react'

/**
 * @type {ReturnType <typeof createContext<{userDetails: User}>>} User Data fetched from hasura
 */
export const UserDetailsContext = createContext()
UserDetailsContext.displayName = 'UserDetailsContext'

export default UserDetailsContext
